import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  contract: generateApiPath({ prefix: AuthLevel.AUTH, name: 'lease-contract' }),
}

export { paths }
